"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 是否是参数类型
 *
 * @param {Object} value 测试的值
 * @return {Boolean}
 */
var is_type_1 = require("./is-type");
var isError = function (value) {
    return is_type_1.default(value, 'Error');
};
exports.default = isError;
//# sourceMappingURL=is-error.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/is-error.js
// module id = 1117
// module chunks = 37